<footer class="site-footer">
  <div class="site-footer-logos">
    <img src="/perte-logos/ESFBTEUN.png" alt="Financiado por la Unión Europea - Next Generation EU" />
    <img src="/perte-logos/LMTERD.webp" alt="Ministerio para la Transición Ecológica y el Reto Demográfico" />
    <img src="/perte-logos/LPRTR3LC.png" alt="Proyecto Estratégico para la Recuperación y Transformación Económica (PERTE) de Digitalización del Ciclo del Agua" />
  </div>
  <p class="site-footer-attribution">
    PNOA · Catastro · CC BY 4.0 <a href="http://scne.es" target="_blank" rel="noopener noreferrer">scne.es</a> | © Real Acequia de Moncada
  </p>
</footer>
